module.exports = __webpack_public_path__ + "img/10551395_L.d27b9b77.png";